import type { TaskOutput } from "@orsane/schema/tasks";
import { createContext, use } from "react";
import type { TaskQueryParams } from "@/types/list";

export type TaskQueryParamsContextValue = TaskQueryParams & {
    parentTask?: TaskOutput;
    /** Called by mutations on success. Nested contexts (e.g. subtasks) use this
     *  to invalidate the outer table's query without a broad cache-wide invalidation. */
    onMutationSuccess?: () => void;
};

const TaskQueryParamsContext = createContext<TaskQueryParamsContextValue | null>(null);

export function TaskQueryParamsProvider({
    value,
    children,
}: {
    value: TaskQueryParamsContextValue;
    children: React.ReactNode;
}) {
    return <TaskQueryParamsContext value={value}>{children}</TaskQueryParamsContext>;
}

export function useTaskQueryParams(): TaskQueryParamsContextValue {
    const context = use(TaskQueryParamsContext);
    if (!context) {
        throw new Error("useTaskQueryParams must be used within a TaskQueryParamsProvider");
    }
    return context;
}
